import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["disabled", "required", "multiple"];
const _hoisted_2 = ["value", "disabled"];
import { ref, watch } from 'vue';
import log from "../../services/Logger";
import trans from '../../services/Translator';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlBoolSelect',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const choices = [
            { value: '', label: trans('') },
            { value: 'true', label: trans('boolean.true') },
            { value: 'false', label: trans('boolean.false') },
        ];
        const model = ref(toModel(props.data));
        const fieldOptions = props.field.options || {};
        watch(() => props.data, updateModel);
        function updateModel() {
            model.value = toModel(props.data);
        }
        function toModel(value) {
            if (value === undefined || value === null || value === '') {
                return '';
            }
            else if (value === 'true') {
                return 'true';
            }
            else if (value === 'false') {
                return 'false';
            }
            else {
                return (!!value) ? 'true' : 'false';
            }
        }
        function toBoolean(v) {
            if (v === '') {
                return undefined;
            }
            else if (v === 'true') {
                return true;
            }
            else if (v === 'false') {
                return false;
            }
        }
        function onChange() {
            const newBoolean = toBoolean(model.value);
            log('FieldControlBoolRadio@change', props.field.name, model.value, newBoolean);
            emit('change', newBoolean);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                    onChange: onChange,
                    disabled: _unref(fieldOptions).disabled ?? undefined,
                    required: _unref(fieldOptions).required ?? undefined,
                    multiple: _unref(fieldOptions).multiple ?? undefined,
                    class: "form__control"
                }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(choices, (choice) => {
                        return _createElementVNode("option", {
                            value: choice.value,
                            key: choice.value,
                            disabled: choice.disabled
                        }, _toDisplayString(choice.label), 9, _hoisted_2);
                    }), 64))
                ], 40, _hoisted_1), [
                    [_vModelSelect, model.value]
                ])
            ]));
        };
    }
});
